import { render } from "./IconPermissionLocked.vue?vue&type=template&id=6b569068"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/icon/IconPermissionLocked.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6b569068"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6b569068', __exports__)) {
    api.reload('6b569068', __exports__)
  }
  
  module.hot.accept("./IconPermissionLocked.vue?vue&type=template&id=6b569068", () => {
    api.rerender('6b569068', render)
  })

}


export default __exports__